import * as React from "react"
import ServiceCardComponent from "./service-card-component"
import * as Model from "../../../../model"
import { isHisGroup } from "../../../../domain/sfp/service-group-domain"
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux"
import * as actionCreators from "../../../../action-creators"
import { ReducerState, MappedActionsProps } from "../../../../reducer"
import { RouteComponentProps } from "react-router"
import { findServiceGroups, deleteServiceGroup,findPolitique } from "../../../../service/sfp/service-group-service"
import { findServicesBL } from "../../../../service/sfp/berger-levrault-ws-service"

class ServiceCard extends React.Component<InjectedProps, State> {
	private loadingServices: boolean = false
	private loadingServicesBL: boolean = false
	private loadingGroups: boolean = false
	private groupsLoaded: boolean = false
	private servicesLoaded: boolean = false
	private servicesBLLoaded: boolean = false

	constructor(props) {
		super(props)
		this.state = {
			addGroup: false,
			addService: false,
			data: [],
			groups: [],
			Politique:[],
			services: [],
			servicesBL: [],
			viewGroup: null,
			viewService: null
		}
	}

	componentDidMount() {
		this.initData(this.props)
	}

	componentWillReceiveProps(props: InjectedProps) {
		this.initData(props)
	}

	componentWillUnmount() {
		this.loadingServices = false
		this.loadingServicesBL = false
		this.loadingGroups = false
		this.groupsLoaded = false
		this.servicesLoaded = false
		this.servicesBLLoaded = false
	}

	render() {
		const loading = this.props.loading || this.loadingServices || this.loadingGroups || this.loadingServicesBL
		return <ServiceCardComponent loading={loading}
		addGroup={this.state.addGroup}
		addService={this.state.addService}
		data={this.state.data}
		groups={this.state.groups}
		Politique={this.state.Politique}
		onAddServiceError={(r) => this.handleError(r)}
		onAddGroupError={(r) => this.handleError(r)}
		onClickAddGroup={() => this.handleClickAddGroup()}
		onClickAddService={() => this.handleClickAddService()}
		onClickViewGroup={(group) => this.handleClickViewGroup(group)}
		onClickViewService={service => this.handleClickViewService(service)}
		onCloseAddService={() => this.handleCloseAddServiceModal()}
		onCloseAddGroup={() => this.handleCloseAddGroupModal()}
		onCloseEditModal={() => this.handleCloseEditServiceModal()}
		onCloseEditGroup={() => this.handleCloseEditGroup()}
		onEditGroupError={(r) => this.handleError(r)}
		onEditServiceError={r => this.handleError(r)}
		onGroupCreated={(g) => this.handleServiceGroupCreated(g)}
		onGroupUpdated={(g) => this.handleServiceGroupUpdated(g)}
		onServiceCreated={(s) => this.handleServiceCreated(s)}
		onServiceUpdated={s => this.handleServiceUpdated(s)}
		onGroupDeleted={(g) => this.handleServiceGroupDeleted(g)}
		localAuthority={this.props.localAuthority}
		services={this.state.services}
		servicesBL={this.state.servicesBL}
		viewGroup={this.state.viewGroup}
		viewService={this.state.viewService}/>
	}

	private buildData(): void {
		if (this.state.services && 0 !== this.state.services.length) {
			const data: DataType[] = [ ...this.state.groups ]
			this.state.services.forEach(service => {
				let grpId = isHisGroup(data, service)
				if (grpId) {
					let index = data.findIndex(grp => grp.id === grpId)
					data.splice(index + 1, 1, service)
				} else {
					data.push(service)
				}
			})
			this.setState({ data })
		}
	}

	private initData(props: Props): void {
		const localAuthority = props.localAuthority
		this.setState({ services: props.services })
		// if (!localAuthority || (props.services && 0 !== props.services.length) ||
		// 	0 !== this.state.groups.length ) return
		// if ((this.loadingServices || this.servicesLoaded) ||
		// 	(this.loadingGroups || this.groupsLoaded) ||
		// 	(this.loadingServicesBL || this.servicesBLLoaded)) return

		this.loadingGroups = true

		findServiceGroups(localAuthority)
		.then(groups => {
			this.loadingGroups = false
			this.groupsLoaded = true
			this.setState({ groups }, () => {
				this.buildData()
			})
		}, reason => {
			this.loadingGroups = false
			this.groupsLoaded = false
		})

		findPolitique(localAuthority)
		.then(Politique => {
			this.loadingGroups = false
			this.setState({ Politique })
		}, reason => {
			this.loadingGroups = false
		})

		if (localAuthority.bergerLevrault && localAuthority.bergerLevrault.enabled) {
			this.loadingServicesBL = true

			findServicesBL(localAuthority.id)
			.then(servicesBL => {
				this.loadingServicesBL = false
				this.servicesBLLoaded = true
				this.setState({ servicesBL: servicesBL.sort(function(a, b){
					if(a.codeElement < b.codeElement) { return -1; }
					if(a.codeElement > b.codeElement) { return 1; }
					return 0;
				}) })
			}, reason => {
				this.loadingServicesBL = false
				this.servicesBLLoaded = false
			})
		}
	}

	private handleClickAddGroup() {
		this.setState({ addGroup: true })
	}

	private handleClickAddService() {
		this.setState({ addService: true })
	}

	private handleCloseAddServiceModal() {
		this.setState({ addService: false })
	}

	private handleCloseAddGroupModal() {
		this.setState({ addGroup: false })
	}

	private handleCloseEditGroup() {
		this.setState({ viewGroup: null })
	}

	private handleCloseEditServiceModal(): void {
		this.setState({ viewService: null })
	}

	private handleClickViewGroup(group: Model.ServiceGroup): void {
		this.setState({ viewGroup: group })
	}

	private handleClickViewService(service: Model.Service): void {
		this.setState({ viewService: service })
	}

	private handleServiceCreated(service: Model.Service): void {
		this.setState(prevState => {
			prevState.services.push(service)
			this.buildData()
			return { addService: false, services: prevState.services}
		}, () => this.buildData())
	}

	private handleServiceUpdated(service: Model.Service): void {
		const id = this.props.currentLocalAuthority.id
		this.setState(prevState => {
			const i = prevState.services.findIndex(s => s.id === service.id)
			const groupIndex = i !== -1 ? prevState.groups.findIndex(grp => grp.id === prevState.services[i].serviceGroup || grp.id === service.serviceGroup) : null
			const serviceFind = (groupIndex !== -1 && groupIndex !== null) ? prevState.groups[groupIndex].services.findIndex(s => s === service.id) : null
			if ((serviceFind !== null || serviceFind !== -1) && prevState.services[i].serviceGroup !== service.serviceGroup) {
				service.serviceGroup === null && (groupIndex !== -1 && groupIndex !== null)
				? prevState.groups[groupIndex].services.splice(serviceFind, 1)
				: prevState.groups[groupIndex].services.push(service.id)
			}
			prevState.services[i] = service

			return { viewService: null, services: prevState.services, groups: prevState.groups }
		}, () => {
			this.props.actions.updateServicesLocally(this.state.services)
			this.props.actions.fetchCurrentLocalAuthorityIfCollectivitiesPage(id)
			this.buildData()
		})
	}

	private handleServiceGroupCreated(group: Model.ServiceGroup): void {
		this.setState(prevState => {
			prevState.groups.push(group)
			return { addGroup: false, groups: prevState.groups}
		}, () => this.buildData())
	}

	private handleServiceGroupUpdated(group: Model.ServiceGroup): void {
		this.setState(prevState => {
			const i = prevState.groups.findIndex(g => g.id === group.id)
			prevState.groups[i] = group
			return { viewGroup: null, groups: prevState.groups}
		}, () => this.buildData())
	}

	private handleServiceGroupDeleted(group: Model.ServiceGroup): void {
		deleteServiceGroup(group).then(() =>
			this.setState(prevState => {
				const i = prevState.groups.findIndex(g => g.id === group.id)
				prevState.groups[i].services.forEach(s => {
					const j = prevState.services.findIndex(srvc => srvc.id === s)
					prevState.services[j].serviceGroup = null
				})
				prevState.groups.splice(i, 1)
				return { viewGroup: null, groups: prevState.groups, services: prevState.services}
			}, () => this.buildData())
		)
	}

	private handleError(reason: any): void {
		this.props.actions.throwError(reason)
	}
}

function mapDispatchToProps(dispatch: Dispatch<ReducerState>): MappedActionsProps {
	return { actions: bindActionCreators(actionCreators, dispatch) }
}

function mapStateToProps(state: ReducerState): ReducerState {
	return state
}

export default connect(mapStateToProps, mapDispatchToProps)(ServiceCard)

export interface ServicesProps {}

export type DataType = (Model.ServiceGroup | Model.Service)

export interface Props {
	loading: boolean
	localAuthority: Model.LocalAuthority
	services: Model.Service[]
}

interface State {
	addGroup: boolean
	addService: boolean
	data: DataType[]
	groups: Model.ServiceGroup[]
	Politique:any
	services: Model.Service[]
	servicesBL: Model.ElementAnalytiqueBergerLevrault[]
	viewGroup: Model.ServiceGroup
	viewService: Model.Service
}

type InjectedProps = MappedActionsProps &
Props &
ReducerState



// WEBPACK FOOTER //
// ./src/component/local-authority/local-authority-detail/service-card/index.tsx